import React from 'react';
import PropTypes from 'prop-types';
import { PaginationButton } from 'common/components/Pagination/PaginationButton';

const NextButton = ({ hasNext, onClick }) => (
  <PaginationButton direction="right" callback={onClick} disabled={!hasNext} />
);

NextButton.propTypes = {
  hasNext: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default NextButton;
